<template>
    <v-container>
        <v-label>{{$t('company.edit')}}</v-label>
        <v-form ref="form"
                v-model="isFormValid">
            <v-container>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('company.name')"
                                  :placeholder="$t('company.name')"
                                  v-model="company.name"
                                  :rules="nameRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('company.domain')"
                                  :placeholder="$t('company.domain')"
                                  v-model="company.domain"
                                  :rules="domainRules"></v-text-field>
                </v-row>
            </v-container>
        </v-form>
        <v-row>
            <v-col>
                <v-btn color="primary" @click="saveCompany" :disabled="!isFormValid">
                    {{$t('save')}}
                </v-btn>
            </v-col>
            <v-col>
                <v-btn color="red" dark @click="deleteCompany">
                    {{$t('delete')}}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {computed, ref} from '@vue/composition-api'
    import {useGet} from "feathers-vuex";

    export default {
        name: 'CompanyAdd',
        setup(props, {root}) {
            const {Company} = root.$FeathersVuex.api;

            const companyId = computed(() => root.$route.params.companyId);
            const {item: company, isPending} = useGet({model: Company, id: companyId});

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const domainRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const saveCompany = () => {
                company.value.save().then(() => {
                    root.$router.replace({name: 'company-list'});
                }, root.$handleFeatherError.bind(root));
            };

            const deleteCompany = () => {
                if (confirm(root.$t('company.confirm_delete'))) {
                    company.value.remove().then(() => {
                        root.$router.replace({name: 'company-list'});
                    }, root.$handleFeatherError.bind(root));
                }
            };

            return {
                company,
                nameRules,
                domainRules,
                isFormValid,
                saveCompany,
                deleteCompany
            }
        },
    }
</script>